import {Component, OnInit} from '@angular/core';
import {HelpPageComponent} from '../../help-page.component';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-graphics',
    templateUrl: './help-page-graphics.component.html',
    styleUrls: ['./help-page-graphics.component.scss', '../../helpPageModule.scss'],
    standalone: false
})
export class HelpPageGraphicsComponent extends HelpPageComponent implements OnInit
{
    urlLanguage: string;

    constructor(public translate: TranslateService)
    {
        super(translate);
    }

    ngOnInit(): void
    {
        this.urlLanguage = this.translate.currentLang;
    }
    public readonly environment = environment;
}
